import moment from "moment";
import { TIME_FORMATS } from "../constants/timeFormats";

export default function useDateTime(date, includeFractionalSeconds) {
  const obj = {
    isValid: null,
    format: null,
    simpleDate: null,
    simpleDateTime: null,
    ago: null,
    until: null,
  };

  const momentDate = moment(date);
  obj.isValid = momentDate.isValid();

  const format = includeFractionalSeconds
    ? TIME_FORMATS.FULL_WITH_FRACTIONAL_SECONDS
    : TIME_FORMATS.LOCALIZED_SHORT;
  obj.format = momentDate.format(format);

  obj.simpleDate = momentDate.format(TIME_FORMATS.SIMPLE_DATE);
  obj.simpleDateTime = momentDate.format(TIME_FORMATS.SIMPLE_DATE_TIME);

  obj.ago = momentDate.fromNow();
  obj.until = moment().to(date);

  return obj;
}
